import api_fabric from "../../api/ApiFabric";
import get_user_store from "@libs/authorization/user_store";
/**
 *
 * @return {BpGlobal}
 */
const api = function() {
  return api_fabric.getInstance("Global", true);
};
/**
 *
 * @return {BpUser}
 */

const user_store = get_user_store(api);

const state = Object.assign({}, user_store.state, {
  cur_language: null,
  bp_user: {},
  is_client: false,
  is_closed: false,
  //TODO: set missions by default
  cur_screen: "missions", // missions, shop, loot, stats, arsenal
});

const mutations = Object.assign({}, user_store.mutations, {
  writeCurrentLanguage(state, data) {
    state.cur_language = data;
  },
  writeBpUser(state, user_data) {
    state.bp_user = user_data;
  },
  writeUserStatus(state, new_status) {
    state.bp_user.status = new_status;
  },
  writeIsClient(state) {
    state.is_client = true;
  },
  writeCurScreen(state, new_screen) {
    state.cur_screen = new_screen;
  },
  writeClosedBattlepass(state, new_state) {
    state.is_closed = new_state;
  },
});

const getters = Object.assign({}, user_store.getters, {
  getUserData(state) {
    return Object.assign({}, state.bp_user, state.global_user);
  },
  isClosed(state) {
    return state.is_closed;
  },
  getUserBpStatus(state) {
    return state.bp_user.status;
  },
  getUserBp(state) {
    return state.bp_user;
  },
  userHasAccess(state) {
    return state.bp_user.status === "trial" || state.bp_user.status === "member";
  },
  userIsTrial(state) {
    return state.bp_user.status === "trial";
  },
  isClient(state) {
    return state.is_client;
  },
  getLang(state) {
    return state.cur_language;
  },
  getScreen(state) {
    return state.cur_screen;
  },
  getProjectUserEmail() {
    return state.project_user.email;
  },
});

const actions = Object.assign({}, user_store.actions, {
  battlepassStatus() {
    return new Promise(resolve => {
      api()
        .getBattlepassStatus()
        .then(response => {
          resolve(response.success.data.data);
        });
    });
  },

  appStartInit({ dispatch, state, commit }) {
    return dispatch("battlepassStatus").then(response => {
      if (response.is_enabled) {
        return dispatch("getProjectUser").then(() => {
          if (state.project_user.state === "auth") {
            return dispatch("getInitData");
          }
          commit("writeClosedBattlepass", false);
          return true;
        });
      } else {
        commit("writeClosedBattlepass", true);
      }
    });
  },

  getInitData({ commit }) {
    return new Promise(resolve => {
      api()
        .getUserInfo()
        .then(response => {
          if (response.success) {
            commit("writeBpUser", response.success.data.data);
            resolve();
          }
        });
    });
  },

  startEvent({ commit }) {
    return new Promise(resolve => {
      api()
        .startEvent()
        .then(response => {
          if (response.success) {
            commit("writeUserStatus", "member");
            resolve();
          }
        });
    });
  },
});

const global_store = {
  namespaced: true,
  state,
  mutations,
  getters,
  actions,
};

export default global_store;
